import httpStore from "@/api/httpStore.js";

export function getProcedures(procedureName) {
  return httpStore
    .get(`/procedures/set/${procedureName}`)
    .then(res => res.data)
    .catch(e => {
      throw e;
    });
}

export function requestDispatchProcedure(category, procedureName) {
  return httpStore
    .post(`/procedures/execute/`, {
      procedureName: procedureName,
      category: category
    })
    .then(res => res.data)
    .catch(e => {
      throw e;
    });
}
export function requestCancelProcess(category, procedureName) {
  return httpStore
    .post(`/procedures/cancel/`, {
      procedureName: procedureName,
      category: category
    })
    .then(res => res.data)
    .catch(e => {
      throw e;
    });
}
